// extracted by mini-css-extract-plugin
module.exports = {"root":"Notice_root__ANVFt","info":"Notice_info__Co5mD","success":"Notice_success__914KY","warning":"Notice_warning__8DYi6"};